import { type MouseEvent, type PropsWithChildren } from 'react';
import { css, cx, type Styles } from '../../../../../../styled-system/css';
import {
  button,
  type ButtonVariantProps,
} from '../../../../../../styled-system/recipes';

export type ButtonProps = ButtonVariantProps & {
  css?: Styles;
  disabled?: boolean;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
};

export const Button = ({
  children,
  css: cssProp,
  size,
  use,
  ...props
}: PropsWithChildren<ButtonProps>) => {
  return (
    <button {...props} className={cx(button({ size, use }), css(cssProp))}>
      {children}
    </button>
  );
};
